// extracted by mini-css-extract-plugin
module.exports = {"marker-img":"styles_marker-img__EFNs4","markerImg":"styles_marker-img__EFNs4"};